
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/companies/[company]",
      function () {
        return require("private-next-pages/companies/[company].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/companies/[company]"])
      });
    }
  